import { React, useState } from 'react';
import { Link } from 'react-router-dom';

// pipes
import { DisplayDate } from "shared/pipes/display-date";

// components
import { ChargeButton } from "./charge-button";
import { InvestigateButton } from "./investigate-button";

const MissingRow = ({ item, count }) => {
    const [isHidden, setIsHidden] = useState(false);

    const { barcode, user, log } = item;

    const onChange = () => {
        setIsHidden(true);
    };

    if (!item) { return null; }

    return (
        <tr id={count}>
            <th component="th" scope="row">
                <Link target="_blank" to={`/products/${barcode}`}>{barcode}</Link>
            </th>
            <th>{user && user.first_name} {user && user.last_name}</th>
            <th>
                {user && (
                    <Link target="_blank" to={`/closet-hackers/${user.id}`}>{user.email}</Link>
                )}
            </th>
            <th>
                <DisplayDate>
                    {log ? log.addedToBox : 'no data'}
                </DisplayDate>
            </th>
            <th>
                <DisplayDate>
                    {log ? log.declared_missing : 'no data'}
                </DisplayDate>
            </th>
            <th width="5%">
                <InvestigateButton hidden={isHidden} item={item} onChange={onChange} />
            </th>
            <th width="5%">
                <ChargeButton hidden={isHidden} item={item} onChange={onChange} />
            </th>
        </tr>
    );
}

export { MissingRow };
